var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareVia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#9B88AF",
    strokeWidth: 1.6,
    cx: 35,
    cy: 28,
    r: 23.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8 29.4a1.2 1.2 0 011.192 1.06l.008.14v4.8a3.6 3.6 0 01-3.388 3.594L43.4 39H26.6a3.608 3.608 0 01-3.594-3.389L23 35.4v-4.8a1.2 1.2 0 012.392-.14l.008.14v4.8c0 .61.468 1.122 1.061 1.192l.139.008h16.8a1.2 1.2 0 001.192-1.06l.008-.14v-4.8a1.2 1.2 0 011.2-1.2zM35.735 15.252l.114.1 6 6a1.2 1.2 0 01-1.584 1.796l-.114-.1-3.951-3.95V30a1.2 1.2 0 01-2.392.14L33.8 30V19.098l-3.951 3.95a1.2 1.2 0 01-1.584.1l-.114-.1a1.2 1.2 0 01-.1-1.583l.1-.114 6-6a1.2 1.2 0 011.463-.183l.121.084z",
    fill: "#9B88AF"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#9B88AF",
    strokeWidth: 1.6,
    cx: 35,
    cy: 28,
    r: 23.2
  }))));
}

export default SvgShareVia;